module.exports = __webpack_public_path__ + "img/GHS.4fa0a2ec.jpg";